module.exports = __webpack_public_path__ + "static/img/swiper_slide_bg.4dd3694.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/swiper_slide_bg.png
// module id = ogoP
// module chunks = 0